import script from "./onceImg.vue?vue&type=script&setup=true&lang=js"
export * from "./onceImg.vue?vue&type=script&setup=true&lang=js"

import "./onceImg.vue?vue&type=style&index=0&id=17ddcdb6&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17ddcdb6"]])

export default __exports__